L.DraggableMiniMap = L.Class.extend({
    options: {
        zoom: 3,
        height: 200,
        width: 200,
        position: {
            x: 0,
            y: 0
        },
        drawMarker: true
    },

    //layer is the map layer to be shown in the minimap
    initialize: function (options) {
        L.Util.setOptions(this, options);

        this._layer = options.layer;
    },

    addTo: function (map) {
        this._mainMap = map;

        var size = this._mainMap.getSize();

        if (!this.options.viewport) {
            this.options.viewport = { // default viewport to map dimensions if not set
                height: size.y,
                width: size.x
            };
        }

        if (!this.options.container) {
            this.options.container = this._mainMap._controlContainer;
        }

        // Creating the container and stopping events from spilling through to the main map.
        this._container = L.DomUtil.create('div', 'leaflet-draggable-minimap', this.options.container);
        this._container.style.width = this.options.width + 'px';
        this._container.style.height = this.options.height + 'px';
        this._container.style.display = 'block';

        this._setPosition(this.options.position);

        L.DomEvent.disableClickPropagation(this._container);
        L.DomEvent.on(this._container, 'mousewheel', L.DomEvent.stopPropagation);

        this._miniMap = new L.Map(this._container, {
            attributionControl: false,
            dragging: false, // disable map panning
            zoomControl: false,
            touchZoom: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            minZoom: 1,
            maxZoom: 17
        });

        this._miniMap.setView(this._mainMap.getCenter(), this.options.zoom);

        this._miniMap.addLayer(new L.TileLayer.NoGap(this.options.layer.tileLayerUrlTemplate, this.options.layer.tileLayerOptions));
        //this._miniMap.addLayer(L.mapbox.tileLayer(this._layer));
        this._zoomControl = new L.Control.Zoom({ position: 'topright' });
        this._initDragging();

        this._mainMap.on('moveend', this._onMainMapMoved, this);
        this._mainMap.on("resize", this._onMainMapResize, this);

        this._addLabelsTileLayer(this.options.labelsLayer);

        this._miniMap.whenReady(L.Util.bind(function () {
            if (this.options.drawMarker) {
                this._drawMarker();
            }

        }, this));


        return this._container;
    },

    remove: function () {
        if (!this._miniMap) {
            return;
        }

        this._removeEventListeners();
        this._miniMap.removeLayer(this._layer);

        if (this._container.parentNode) {
            this._container.parentNode.removeChild(this._container);
        }
    },

    onAdd: function (map) {

    },

    onRemove: function () {

    },

    enableEdit: function () {
        this._draggable.enable();
        this._zoomControl.addTo(this._miniMap);
        this._addEventListeners();
    },

    disableEdit: function () {
        if (this._zoomControl.getContainer()) {
            this._zoomControl.removeFrom(this._miniMap);
        }

        this._draggable.disable();
        this._removeEventListeners();
    },

    setZIndex: function (zIndex) {
        this._container.style.zIndex = zIndex;
    },

    _addEventListeners: function () {
        if (this._miniMap) {
            this._miniMap.on('zoomend', this._onMiniMapZoomChange, this);
        }
    },

    _removeEventListeners: function () {
        if (this._miniMap) {
            this._miniMap.on('zoomend', this._onMiniMapZoomChange, this);
        }
    },

    _initDragging: function () {
        this._draggable = new L.Draggable(this._container);

        this._draggable.on({
            dragend: this._onDragEnd
        }, this);
    },

    _onDragEnd: function (e) {
        this._zoomControl.setPosition("topright"); // small hack to re-position the zoom control, to get around css position issues while dragging

        var center = this._getMapCenter();

        var minimapOffsetFromMapCenter = {
            x: e.target._newPos.x - center.x,
            y: e.target._newPos.y - center.y
        };

        var newPosition = this._setPosition(minimapOffsetFromMapCenter);

        this.options.position = newPosition;
        this._mainMap.fire("miniMapMoved", newPosition);
    },

    _getMapCenter: function () {
        var size = this._mainMap.getSize();

        var centerX = Math.round(size.x / 2);
        var centerY = Math.round(size.y / 2);

        return {
            x: centerX,
            y: centerY
        };
    },

    _getViewportXY: function () {
        var size = this._mainMap.getSize();

        var viewportX = Math.round((size.x - this.options.viewport.width) / 2);
        var viewportY = Math.round((size.y - this.options.viewport.height) / 2);

        return {
            x: viewportX,
            y: viewportY
        };
    },

    _setPosition: function (pos) {
        var center = this._getMapCenter();

        var positionInMap = {
            x: center.x + pos.x,
            y: center.y + pos.y
        };

        var viewport = this._getViewportXY();

        // make sure it's not going outside the viewport
        var boundedPos = {
            x: Math.min(positionInMap.x - viewport.x > 0 ? positionInMap.x : viewport.x, (viewport.x + this.options.viewport.width) - this.options.width),
            y: Math.min(positionInMap.y - viewport.y > 0 ? positionInMap.y : viewport.y, (viewport.y + this.options.viewport.height) - this.options.height)
        };

        L.DomUtil.setPosition(this._container, new L.Point(boundedPos.x, boundedPos.y));

        var boundedPosFromMapCenter = {
            x: boundedPos.x - center.x,
            y: boundedPos.y - center.y
        };

        return boundedPosFromMapCenter;
    },

    _drawMarker: function () {
        if (this._marker) {
            this._miniMap.removeLayer(this._marker);
        }

        var icon = L.icon({
            iconUrl: '/content/img/xh.png',
            iconSize: L.point(27, 30),
            iconAnchor: L.point(12, 15)
        });

        this._marker = L.marker(this._mainMap.getCenter(), {
            clickable: false,
            icon: icon
        }).addTo(this._miniMap);
    },

    _onMiniMapZoomChange: function (e) {
        this._mainMap.fire("miniMapZoomChange", { zoom: e.target._zoom });
    },

    _onMainMapMoved: function (e) {
        // update minimap center
        this._miniMap.setView(this._mainMap.getCenter());

        if (this.options.drawMarker) {
            this._drawMarker();
        }
    },

    _onMainMapResize: function () {
        this._setPosition(this.options.position);
    },

    _addLabelsTileLayer: function (labelsLayer) {
        if (labelsLayer) {
            var paneName = 'mapforge-tiles';

            this._miniMap.createPane(paneName);

            this.options.labelsLayer.tileLayerOptions.pane = paneName;

            this._miniMap.addLayer(new L.TileLayer.NoGap(this.options.labelsLayer.tileLayerUrlTemplate, this.options.labelsLayer.tileLayerOptions));
        }
    }
});

L.draggableMinimap = function (options) {
    return new L.DraggableMiniMap(options);
};
define("leaflet-minimap", function(){});

